module.exports = __webpack_public_path__ + "img/image-ramsesmiron.eaf07ed6.webp";